<template lang="html">
  <div :class="[tags.length > 0 ? 'has-tag' : '', 'auto-complete-tag-input']">
    <vue-tags-input
      v-model="tag"
      :tags="tags"
      @tags-changed="tagsChanged"
      :autocomplete-items="autocompleteItems"
      :add-only-from-autocomplete="true"
      @before-adding-tag="addingTag"
      placeholder="Type what California county you want to add here"
    >
    </vue-tags-input>
  </div>
</template>

<script>
import _ from 'lodash';
import VueTagsInput from '@johmun/vue-tags-input';
import axios from 'axios'

export default {
  components: { VueTagsInput },
  props: {
    'autocompleteSourceURL': {
      type: String,
      default: `${process.env.VUE_APP_ANALYTIC_SERVER}regions/california/autocomplete?term=`
    },
    tagsList: {
      type: Array,
      default: () => { return [] },
    },
  },
  data() {
    return {
      tag: '',
      tags: this.tagsList,
      autocompleteItems: [],
    }
  },
  watch: {
   'tag': 'loadAutoCompleteItems',
  },
  methods: {
    addingTag(handler) {
      var id = handler.tag.id
      if (!id) return
      var url = `${process.env.VUE_APP_ANALYTIC_SERVER}regions/california/contains?id=${id}`
      axios.get(url).then(response => {
        this.tags = this.tags.concat(_.map(response.data, (tag) => { return { text: tag.PRETTYNAME, id: tag.ID } }))
        this.autocompleteItems = []
        this.$emit('tags-changed', this.tags)
        this.tag = ''
      }).catch(() => alert('Something went wrong! Please try again later.'));
    },
    tagsChanged(newTags) {
      this.autocompleteItems = [];
      this.tags = newTags;
      this.$emit('tags-changed', newTags)
      this.tag = ''
    },
    loadAutoCompleteItems() {
      if (this.tag.length < 2) {
        this.autocompleteItems = []
        return;
      }
      const url = `${this.autocompleteSourceURL}${this.tag}`;

      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        axios.get(url).then(response => {
          this.autocompleteItems = response.data.map(a => {
            return { text: a.prettyname, id: a.ID };
          });
        }).catch(() => alert('Something went wrong! Please try again later.'));
      }, 600);
    },
  },
}
</script>

<style lang="scss">
.auto-complete-tag-input {
  .has-tag {
    ul.ti-tags  {
      padding: 48px 0 8px 0;
    }
  }

  .vue-tags-input {
    .ti-input {
      padding: 0;
      border: none !important;
    }

    .ti-autocomplete {
      top: 45px;
      border: 1px solid #DDDDDD;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;

      .ti-item {
        background: white;

        div {
          padding: 12px 16px;
          color: #6D6D6D
        }
      }

      .ti-selected-item {
        background: #F5F7F6;

        div {
          color: #171717;
        }
      }
    }
  }

  ul.ti-tags {
    position: relative;
    padding: 40px 0 0 0;
    background: white;

    .ti-tag {
      margin-top: 12px;
      background: #6d6d6d;
    }

    .ti-tag * {
      color: white;
    }

    .ti-new-tag-input-wrapper {
      position: absolute;
      top: 0;
      width: 100%;
      padding: 0;
      margin: 0;

      input {
        padding: 12px 16px;
        // border-bottom: 1px solid #DCDFFB !important;

        &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
          color: #8e8e8e;
          opacity: 1; /* Firefox */
        }

        &:-ms-input-placeholder { /* Internet Explorer 10-11 */
          color: #8e8e8e;
        }

        &::-ms-input-placeholder { /* Microsoft Edge */
          color: #8e8e8e;
        }
      }
    }
  }
}
</style>
